import React from 'react'

import styles from '../assets/styles/styles.module.css'
import { PWordmark } from '@porsche-design-system/components-react';

export const HeaderSection = (): React.ReactElement => {

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <PWordmark size="small" />
        </div>
      </div>
    </header>
  )
}